import { useBucket } from '@context/bucket.context';
import useWelcomeVoucherQuery from '@hooks/user/use-welcome-voucher-query';

const useCatalogVoucherBanner = () => {
  const { isFeatureEnabled } = useBucket();
  const isVoucherBannerOnPLPEnabled = isFeatureEnabled((f) => f.enableVoucherBannerOnPlp, true) ?? false;
  const { welcomeVoucher } = useWelcomeVoucherQuery({ touchPoint: 'PLP', enabled: isVoucherBannerOnPLPEnabled });
  const showBanner = isVoucherBannerOnPLPEnabled && !!welcomeVoucher?.text;

  return { showBanner, text: welcomeVoucher?.text };
};

export default useCatalogVoucherBanner;
